import underwritingEngine from "./underwritingEngine";
import quote from "./quote";
import menu from "./menu";
import personInfo from "./personInfo";
import payment from "./payment";
import summaryModelList from "./summaryModelList";
import FileCRUD from "./FileCRUD";
import token from "./token";

export default {
  ...underwritingEngine,
  ...quote,
  ...menu,
  ...personInfo,
  ...payment,
  ...personInfo,
  ...summaryModelList,
  ...FileCRUD,
  ...token,
};
